<template>
    <div class="wrapper">
        <loader :loading="true" v-if="loading"></loader>
        <div class="left">
            <div class="head">
                <div>
                    <TextInputBloc
                        v-if="!isUpdate"
                        :label="'Forecast Ref'"
                        :required="true"
                        :value="formForecast.reference"
                        @input="
                            formForecast.reference = $event;
                            onInputChange();
                        "
                        :validator="FORM_VALIDATORS.name"
                        :max-length="textFieldMaxLength"
                        class="name"
                    ></TextInputBloc>
                </div>
                <div>
                    <TextInputBloc
                        v-if="!isUpdate"
                        :label="'Name'"
                        :required="true"
                        :value="formForecast.name"
                        @input="
                            formForecast.name = $event;
                            onInputChange();
                        "
                        :validator="FORM_VALIDATORS.name"
                        :max-length="textNameFieldMaxLength"
                        class="name"
                    ></TextInputBloc>
                </div>
            </div>
            <div class="divider"></div>
            <section class="middle">
                <!-- Partie Campagnes -->
                <div v-if="brandWithCampaigns">
                    <div v-if="ForecastValidator.canUpdateCampaign(forecast)">
                        <h3>Launch Campaigns *</h3>
                        <div class="campaigns">
                            <div class="campaigns-inner">
                                <div v-for="campaign in campaigns" v-bind:key="campaign.id">
                                    <input
                                        @change="addCampaignById(campaign.id)"
                                        :checked="formForecast.campaign && campaign.id === formForecast.campaign.id"
                                        type="radio"
                                        :value="campaign.id"
                                        :id="'camp-' + campaign.id"
                                        name="campaigns"
                                    />
                                    <label :for="'camp-' + campaign.id">{{ campaign.name }}</label>
                                </div>
                            </div>
                            <br />
                            <div class="launch-date">
                                Campaign:
                                <span v-if="formForecast.campaign">{{ formForecast.campaign.refClient }} • {{ formForecast.campaign.name }}</span
                                ><br />
                                Launch Date :
                                <template v-if="formForecast.campaign">{{ formatDate(formForecast.campaign.launchDate) }}</template
                                ><br />
                                Availability Date :
                                <template v-if="formForecast.campaign">{{ formatDate(formForecast.campaign.availabilityDate) }}</template>
                                <br />
                                <template v-if="formForecast.campaign && formForecast.campaign.preseriesDate != null">
                                    Preseries Date : {{ formatDate(parseDate(formForecast.campaign.preseriesDate)) }} <br />
                                </template>
                                End of Campaign :
                                <template v-if="formForecast.campaign">{{ formatDate(formForecast.campaign.endDate) }}</template>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <h3>Launch Campaigns</h3>
                        <div>{{ forecast.campaign.name }}</div>
                    </div>
                </div>

                <!-- Partie Dates + récurrences -->
                <div class="forecastWindowDates" :class="{ solo: !brandWithCampaigns }">
                    <h3>Forecast Window Dates:</h3>
                    <section>
                        <Datepicker
                            :label="'Start Date *'"
                            :value="formForecast.startDate"
                            :max="formatDate(formForecast.endDate, 'YYYY-MM-DD')"
                            :labelWidth="170"
                            @input="
                                formForecast.startDate = $event;
                                onInputChange();
                            "
                        />
                    </section>
                    <section>
                        <Datepicker
                            :label="'End Date *'"
                            :value="formForecast.endDate"
                            :min="formatDate(formForecast.startDate, 'YYYY-MM-DD')"
                            :labelWidth="170"
                            @input="
                                formForecast.endDate = $event;
                                onInputChange();
                            "
                        />
                    </section>
                    <section>
                        <Datepicker
                            :label="'Launch Date *'"
                            :value="formForecast.launchDate"
                            :labelWidth="170"
                            @input="
                                formForecast.launchDate = $event;
                                onInputChange();
                            "
                            :disabled="isForecastPublished"
                        />
                    </section>
                    <section>
                        <Datepicker
                            :label="'Availability Date *'"
                            :value="formForecast.availabilityDate"
                            :labelWidth="170"
                            @input="
                                setAvailabilityDate($event);
                                onInputChange();
                            "
                            :disabled="isForecastPublished"
                        />
                    </section>
                    <section>
                        <Datepicker
                            :label="'Preseries Date'"
                            :value="formForecast.preseriesDate"
                            :labelWidth="170"
                            @input="
                                formForecast.preseriesDate = $event;
                                onInputChange();
                            "
                            :disabled="isForecastApproved"
                        />
                    </section>
                    <section>
                        <Datepicker
                            :label="'End of Campaign'"
                            :value="formForecast.endOfCampaign"
                            :labelWidth="170"
                            @input="
                                formForecast.endOfCampaign = $event;
                                onInputChange();
                            "
                            :disabled="isForecastPublished"
                        />
                    </section>
                    <section style="margin-top: 20px">
                        <h3>Recurrences:</h3>
                        <SelectBloc
                            :value="formForecast.recurrenceAmount"
                            @change="
                                formForecast.recurrenceAmount = $event === '' ? null : parseInt($event);
                                onInputChange();
                            "
                            :required="true"
                            :options="numberOfRecursionOptions"
                            :label="'Recurrence'"
                            :append-text="'months'"
                            :labelWidth="168"
                        >
                            <template slot="noneValue">
                                <option :value="undefined">Please choose</option>
                            </template>
                        </SelectBloc>
                        <!--                        EVO 2023 : Que months de dispo donn on ne l'affiche pas -->
                        <!--                        <SelectBloc-->
                        <!--                            :value="formForecast.recurrenceType"-->
                        <!--                            @change="-->
                        <!--                                formForecast.recurrenceType = $event === '' ? null : parseInt($event);-->
                        <!--                                onInputChange();-->
                        <!--                            "-->
                        <!--                            :required="true"-->
                        <!--                            :options="recurrenceTypesForSelect"-->
                        <!--                            :label="'Recurrence type'"-->
                        <!--                        >-->
                        <!--                        </SelectBloc>-->
                        <Datepicker
                            :label="'Reference Date *'"
                            :disabled="this.refDateIsEqualToAvailabilityDate || isForecastPublished"
                            :value="formForecast.refDate"
                            :labelWidth="170"
                            @input="
                                formForecast.refDate = $event;
                                onInputChange();
                            "
                        />
                    </section>
                </div>
            </section>
            <div class="divider"></div>
            <section>
                <label for="message" class="uppercase">Message</label
                ><textarea
                    id="message"
                    :value="formForecast.comments"
                    maxlength="5000"
                    @input="
                        formForecast.comments = $event.target.value;
                        onInputChange();
                    "
                />
            </section>
        </div>
        <div class="right">
            <section class="zone-selection">
                <ZoneSelection
                    :selected-zones="formForecast.zones"
                    :forecast="forecast"
                    :disabled="!ForecastValidator.canUpdate(forecast)"
                    @update="updateZones"
                />
                <br /><br />
            </section>
        </div>
    </div>
</template>
<script>
import { FORECAST_STATUS, FUNCTIONALITY, RECURRENCE_TYPE, recurrenceTypeLabel } from "@/components/forecasts/constants";
import ClientColorButton from "@/components/ui/ClientColorButton";
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import FormSectionTitle from "@/components/ui/Form/FormSectionTitle";
import SelectBloc from "@/components/ui/Form/SelectBloc";
import ForecastValidator from "@/components/forecasts/validation/forecastValidator";
import Datepicker from "@/components/forecasts/elements/form/Datepicker";
import { formatDate as fDate, parseDate } from "@/components/forecasts/utils/utilis";
import forecastsService from "@/components/forecasts/forecastsService";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import ZoneSelection from "@/components/forecasts/elements/form/ZoneSelection";
import { removeNbsp } from "../../../utils/string";

export default {
    components: {
        ZoneSelection,
        Datepicker,
        ClientColorButton,
        TextInputBloc,
        FormSectionTitle,
        SelectBloc,
        loader
    },
    mixins: [TryLoad],
    props: {
        forecast: {
            type: Object,
            required: false,
            default: undefined
        },
        isUpdate: {
            type: Boolean,
            required: false,
            default: false
        },
        brandWithCampaigns: {
            type: Boolean,
            required: false,
            default: true
        },
        refDateIsEqualToAvailabilityDate: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            numberOfRecOptions: 18,
            textFieldMaxLength: 40,
            textNameFieldMaxLength: 200,
            RECURRENCE_TYPE,
            FUNCTIONALITY,
            recurrenceTypeLabel,
            ForecastValidator,
            formForecast: null,
            campaigns: [],
            status: null,
            numberOfRecOptionsMin: 0
        };
    },
    computed: {
        recurrenceTypesForSelect() {
            let output = [];
            for (let [key, value] of Object.entries(this.RECURRENCE_TYPE)) {
                output.push({
                    value: value,
                    label: key
                });
            }
            return output;
        },
        isValid() {
            return (
                this.isValidCampaign &&
                this.isValidName &&
                this.isValidReference &&
                this.isValidStartDate &&
                this.isValidRefDate &&
                this.isValidEndDate &&
                this.isValidRecurrenceAmount &&
                this.isValidRecurrenceType &&
                this.isValidZones &&
                this.isValidLaunchDate &&
                this.isValidAvailabilityDate
            );
        },
        isValidCampaign() {
            return (this.brandWithCampaigns && this.formForecast.campaign !== null) || !this.brandWithCampaigns;
        },
        isValidName() {
            return this.formForecast.name.length > 0 && this.formForecast.name.length <= this.textNameFieldMaxLength;
        },
        isValidReference() {
            return this.formForecast.reference.length > 0 && this.formForecast.reference.length < this.textFieldMaxLength;
        },
        isValidStartDate() {
            return this.formForecast.startDate !== null && this.formForecast.startDate < this.formForecast.endDate;
        },
        isValidRefDate() {
            return this.formForecast.refDate !== null;
        },
        isValidEndDate() {
            return this.formForecast.endDate !== null;
        },
        isValidLaunchDate() {
            return this.formForecast.launchDate !== null;
        },
        isValidAvailabilityDate() {
            return this.formForecast.availabilityDate !== null;
        },
        isValidRecurrenceAmount() {
            return !!this.formForecast.recurrenceAmount;
        },
        isValidRecurrenceType() {
            return this.formForecast.recurrenceType;
        },
        isValidZones() {
            if (this.forecast.status === FORECAST_STATUS.DRAFT) {
                return true;
            }
            return this.formForecast.zones.length > 0;
        },
        numberOfRecursionOptions() {
            // Si c'est une modification d'un LF au statut ACTIVE ou CLOSED, on ne peut qu'agmenter le nb de recurrence
            if (this.isUpdate && this.forecast != null && this.forecast.status !== this.isPending && this.forecast.status !== FORECAST_STATUS.DRAFT) {
                return [...Array(this.numberOfRecOptions - this.numberOfRecOptionsMin + 1).keys()].map(i => this.numberOfRecOptionsMin + i);
            }

            // Sinon on peut sélectionner le nombre voulu
            return [...Array(this.numberOfRecOptions).keys()].map(i => i + 1);
        },
        isPending() {
            return this.forecast != null && this.forecast.status === FORECAST_STATUS.PENDING;
        },
        isForecastPublished() {
            return (
                this.isUpdate &&
                (this.forecast.status === FORECAST_STATUS.PENDING ||
                    this.forecast.status === FORECAST_STATUS.ACTIVE ||
                    this.forecast.status === FORECAST_STATUS.CLOSED)
            );
        },
        isForecastApproved() {
            return this.isUpdate && this.forecast.status === FORECAST_STATUS.CLOSED && this.forecast.transmissionApprovalDate !== null;
        }
    },
    async created() {
        this.formForecast = { ...this.forecast };
        if (this.brandWithCampaigns) {
            const campaigns = await this.tryLoad(() => forecastsService.getCampaigns());
            this.campaigns = campaigns.sort((c1, c2) => {
                if (c1.name < c2.name) return -1;
                else if (c1.name > c2.name) return 1;
                else return 0;
            });
        }
        if (this.isUpdate) {
            this.numberOfRecOptionsMin = this.forecast.recurrenceAmount;
        }
    },
    methods: {
        onInputChange() {
            this.formForecast.reference = removeNbsp(this.formForecast.reference);
            this.formForecast.name = removeNbsp(this.formForecast.name);
            this.$emit("update", { forecast: this.formForecast, isValid: this.isValid });
        },
        addCampaignById(campaignId) {
            if (this.brandWithCampaigns) {
                this.formForecast.campaign = this.campaigns.find(camp => camp.id === parseInt(campaignId));

                if (this.formForecast.campaign.availabilityDate instanceof Date) {
                    this.formForecast.refDate = this.formForecast.campaign.availabilityDate;
                    this.formForecast.availabilityDate = this.formForecast.campaign.availabilityDate;
                } else if (this.formForecast.campaign.availabilityDate === null) {
                    this.formForecast.refDate = null;
                    this.formForecast.availabilityDate = null;
                }
                if (this.formForecast.campaign.launchDate instanceof Date) {
                    this.formForecast.launchDate = this.formForecast.campaign.launchDate;
                } else if (this.formForecast.campaign.launchDate === null) {
                    this.formForecast.launchDate = null;
                }
                if (this.formForecast.campaign.endDate instanceof Date) {
                    this.formForecast.endOfCampaign = this.formForecast.campaign.endDate;
                } else if (this.formForecast.campaign.endDate === null) {
                    this.formForecast.endOfCampaign = null;
                }
                if (this.formForecast.campaign.preseriesDate instanceof Date) {
                    this.formForecast.preseriesDate = this.formForecast.campaign.preseriesDate;
                } else if (this.formForecast.campaign.preseriesDate === null) {
                    this.formForecast.preseriesDate = null;
                }
            }
            this.onInputChange();
        },
        setAvailabilityDate($event) {
            this.formForecast.availabilityDate = $event;
            if (this.refDateIsEqualToAvailabilityDate) {
                this.formForecast.refDate = $event;
            }
        },
        formatDate(date, format) {
            return fDate(date, format);
        },
        parseDate(pDate) {
            return parseDate(pDate);
        },
        updateZones(zones) {
            this.formForecast.zones = zones;
            this.onInputChange();
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/themes";
@import "../css/forecasts";
.wrapper {
    text-transform: uppercase;
    display: flex;
    font-weight: bold;
    .left {
        min-width: 1025px;
        background-color: white;
        label {
            max-width: 160px; //TODO modifier ça pour responsive
        }
        .head {
            display: flex;
            margin-bottom: 20px;
        }
        padding: 50px;
        .middle {
            .forecastWindowDates {
                background-color: #f7f7f7;
                padding: 10px;
                flex-basis: 55%;
            }
            display: flex;
            div {
                flex-basis: 50%;
                flex-grow: 0;
                padding: 0 20px 0 0;
                &.solo {
                    flex-basis: auto;
                }
            }
        }
        textarea {
            width: 100%;
            height: 100px;
        }
        .campaigns {
            .campaigns-inner {
                padding: 5px;
                height: 150px;
                overflow: scroll;
                background-color: $color3;
                font-weight: 400;
            }
            .launch-date {
                background-color: #cbcbcb;
                padding: 5px;
            }
        }
    }
    .right {
        background-color: $background-form-2;
        padding: 20px;
        min-width: 20%;
    }
}
.divider {
    border: 1px solid $color1;
    margin: 15px 0;
}
.zone-selection {
    overflow-y: scroll;
    max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// ForecastForm.vue?96441456